import { StandardEvents } from '@shopify/events';
class MnStockNote extends HTMLElement {
  connectedCallback(){this.section=this.closest('.shopify-section');this.section?.addEventListener(StandardEvents.productSelect,this.update);}
  disconnectedCallback(){this.section?.removeEventListener(StandardEvents.productSelect,this.update);}
  update=(event)=>{if(event.target.closest?.('product-card'))return;event.promise?.then(({detail})=>{if(!this.isConnected||!detail?.html)return;const next=[...detail.html.querySelectorAll('mn-stock-note')].find(el=>el.dataset.blockId===this.dataset.blockId);if(next)this.replaceChildren(...[...next.childNodes].map(n=>n.cloneNode(true)));}).catch(()=>{});};
}
class MnLiveViewers extends HTMLElement {
  connectedCallback(){
    if(this.dataset.demo==='true')return;
    this.row=this.querySelector('.mn-live-row');this.text=this.querySelector('[data-live-text]');
    const endpoint=this.dataset.endpoint?.trim();if(!endpoint)return;
    try{this.url=new URL(endpoint,location.origin);if(this.url.origin!==location.origin||!this.url.pathname.startsWith('/apps/'))return;}catch{return;}
    this.url.searchParams.set('product_id',this.dataset.productId);
    this.read();this.timer=setInterval(()=>this.read(),30000);
  }
  disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();}
  async read(){
    if(document.hidden)return;
    this.controller?.abort();this.controller=new AbortController();const timeout=setTimeout(()=>this.controller.abort(),5000);
    try{
      const response=await fetch(this.url,{credentials:'same-origin',cache:'no-store',signal:this.controller.signal});if(!response.ok)throw new Error('Unavailable');
      const data=await response.json();const age=Date.now()-Date.parse(data.measured_at);
      if(String(data.product_id)!==this.dataset.productId||!Number.isSafeInteger(data.active_viewers)||data.active_viewers<=0||!Number.isFinite(age)||age< -5000||age>90000)throw new Error('Invalid or stale data');
      if(!this.isConnected)return;this.text.textContent=this.dataset.label.replaceAll('[count]',String(data.active_viewers));this.row.hidden=false;
    }catch{if(this.row)this.row.hidden=true;}finally{clearTimeout(timeout);}
  }
}
if(!customElements.get('mn-stock-note'))customElements.define('mn-stock-note',MnStockNote);
if(!customElements.get('mn-live-viewers'))customElements.define('mn-live-viewers',MnLiveViewers);
